var map = {
	"./banner-img.gif": 1,
	"./card2.png": 2,
	"./dot.png": 26,
	"./form-bg.jpg": 27,
	"./header-banner.jpg": 28,
	"./list-icon.png": 29,
	"./list-icon.svg": 30,
	"./logo.svg": 31,
	"./movie.jpg": 3,
	"./pazzle.png": 4,
	"./person-list__bg.jpg": 32,
	"./premium-badge.png": 5,
	"./promotions-bg.jpg": 33,
	"./slash.svg": 34,
	"./speaker1.png": 6,
	"./speaker2.png": 7,
	"./speaker3.png": 8,
	"./speaker4.png": 9,
	"./workplan-individ.jpg": 10,
	"./workplan-laptop.jpg": 11,
	"./workplan-questions.jpg": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;